module.exports = __webpack_public_path__ + "static/img/map_jiangxi.6493edb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join/map_jiangxi.png
// module id = y8LE
// module chunks = 0